import React from "react";
import Chart from "react-apexcharts";

function TipoEmpleadoChart() {
  // Opciones y datos para ApexCharts
  const data = {
    options: {
      chart: {
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: true, // Barras horizontales
          barHeight: '50%', // Ajusta la altura de la barra si deseas
        }
      },
      xaxis: {
        categories: ["Docente", "Administrativo"], // Eje "Y" al ser horizontal
        title: {
          text: "Total", // Etiqueta del eje inferior
        },
        labels: {
          formatter: function (val) {
            // Muestra en 'mil' si deseas
            return val / 1000 + " mil";
          }
        }
      },
      yaxis: {
        title: {
          text: "Tipo Empleado"
        }
      },
      // Colores de las barras (opcional)
      colors: ["#8B572A"], // color café aproximado
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          // Muestra texto encima de la barra
          return val / 1000 + " mil";
        },
        offsetX: 50,
        style: {
          colors: ["#313131"], // Cambia el color del texto a #313131
          fontSize: '12px', // Puedes ajustar el tamaño si es necesario
          fontWeight: 'bold' // Opcional, para hacerlo más legible
        }
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#fff", "#f2f2f2"], // alterna color de filas
          opacity: 0.5
        }
      },
      legend: {
        show: false // Oculta leyenda si no la necesitas
      }
    },
    series: [
      {
        name: "Total",  // Nombre de la serie
        data: [44000, 9000] // Valores correspondientes a cada categoría
      }
    ]
  };

  // Renderiza la gráfica
  return (
    <div className="graficas2">
      <h5>Total por Tipo Empleado</h5>
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={200}
      />
    </div>
  );
}

export default TipoEmpleadoChart;
